// extracted by mini-css-extract-plugin
export default {"navigationContainer":"NavigationContainer_navigationContainer__Ww0Le","isLoading":"NavigationContainer_isLoading__7uO84","loader":"NavigationContainer_loader__aHyRS"};